// extracted by mini-css-extract-plugin
export default {"outerDiv":"dashboard-card_outerDiv__lOSDT"};